import {SliderStep} from "../../store/types";

/**
 * 
 * @param numberToConvert Liczba którą chcemy wyświetlić
 * @param symbol Symbol stojący za liczbą np. % lub zł. Jeśli chcemy aby symbol był oddzielony od liczby spacją, należy podać ją w parametrze razem z symbolem np. (" zł")
 * @param asInteger Jeśli "true" wyrzucamy to co po przecinku i prezentujemy liczbę całkowitą
 * @param thousandsSeparator separator oddzielający tysiące
 * @returns {String} Liczba gotowa do prezentacji
 */
export const numberToDisplayString = (numberToConvert: string | number | undefined, symbol?: string, asInteger?: boolean, thousandsSeparator: string = " "): string => {

  if(!numberToConvert){
    return ""
  }

  const numberToDisplayString = numberToConvert.toLocaleString('pl-PL', { maximumFractionDigits: 2, minimumFractionDigits: 2 })
  const splittedNumber = numberToDisplayString.split(',') //Dzięki użyciu poprzedniej funkcji .toLocaleString mamy pewność że liczba zawsze będzie mieć dwa miejsca po przecinku
  const numberWithoutTrailingZeros =  asInteger || splittedNumber[1] === "00"  ? splittedNumber[0] : numberToDisplayString //splittedNumber[0] - Właściwa liczba, splittedNumber[1] - część setna liczby
  const separateThousands = numberWithoutTrailingZeros.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator)
  return `${separateThousands}${symbol || ''}`;
}

/**
 *
 * @param steps Progi kwotowę i wysokość kroku na sliderze jaki jest po przekroczeniu progu
 * @param value Wartość slidera
 * @returns {number} Wartość kroku w sliderze
 */
export const  getStepValueSorted = (steps: SliderStep[], value: number): number => {
  let result =  steps[0].value;

  for (const step of steps) {
    if (value < step.from){
      break;
    }
    result = step.value;
  }
  return result;
}


export function isLaterThanNow(checkingTime: string) {
  const now = new Date();

  const [time, fraction = "0"] = checkingTime.split(".");
  const [hours, minutes, seconds] = time.split(":").map(Number);

  const workFromDate = new Date();
  workFromDate.setHours(hours, minutes, seconds, Number(fraction.slice(0, 3)));

  return workFromDate > now;
}